var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 40,
    viewBox: "0 0 231 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xEB\xA0\x88\xEC\x9D\xB4\xEC\x96\xB4_1",
    clipPath: "url(#clip0_540_2241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5241 0.0575603C31.5979 0.0575603 40.606 8.95875 40.606 19.972C40.606 24.8793 38.8267 29.3868 35.8437 32.8684C35.4995 33.2684 35.0988 33.6669 34.6966 34.0669C31.0815 37.7183 26.0907 39.9439 20.5819 39.9439H0.5V0L20.5241 0.0575603ZM7.61446 32.867H20.5241C27.6385 32.867 33.4337 27.1035 33.4337 20.028C33.4337 12.9525 27.6385 7.18914 20.5241 7.18914H7.61446V32.867Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M82.9438 39.9424H74.9107L71.2392 32.8094L62.4611 15.6918L53.6831 32.8094L50.0116 39.9424H41.9785L45.65 32.8094L62.4611 0L79.2723 32.8094L82.9438 39.9424Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M109.047 26.7612C107.784 24.7067 105.548 23.3371 102.965 23.3371H95.7929V39.9986H88.6206V0.0576172H113.98C116.963 0.0576172 119.659 1.25605 121.611 3.19687C123.562 5.19377 124.766 7.87549 124.766 10.8421C124.766 15.1783 122.184 20.6568 118.454 22.3689C117.479 22.8249 116.446 23.1098 115.355 23.2249L119.641 31.2775L124.766 40H116.733L112.221 32.4582M113.981 16.2055C114.498 16.2055 115.014 16.0919 115.473 15.8631C116.792 15.2919 117.653 13.2316 117.653 11.8058C117.653 10.4937 116.964 8.61639 116.563 8.21642C116.105 7.76037 115.244 7.18919 113.981 7.18919H95.7929V16.2616L113.981 16.204V16.2055Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M171.524 0L167.853 7.13305L151.042 39.9424L134.231 7.13305L130.559 0H138.592L142.264 7.13305L151.042 24.2506L159.82 7.13305L163.491 0H171.523H171.524Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M177.315 39.9424V0H184.487V39.9424H177.315Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M223.329 11.0693V10.8405C223.329 8.84363 221.666 7.18914 219.658 7.18914H203.363C201.355 7.18914 199.692 8.84363 199.692 10.8405V11.0693C199.692 13.0662 201.355 14.7207 203.363 14.7207H217.822C221.551 14.7207 224.879 16.3176 227.174 18.8296C227.347 19.0008 227.461 19.172 227.633 19.3432C229.411 21.5113 230.502 24.3067 230.502 27.3308C230.502 34.2927 224.822 39.941 217.822 39.941H205.257C198.257 39.941 192.577 34.2927 192.577 27.3308H199.749C199.749 30.355 202.216 32.8079 205.257 32.8079H217.822C220.863 32.8079 223.387 30.355 223.387 27.3308C223.387 24.3067 220.863 21.8537 217.822 21.8537H203.363C200.437 21.8537 197.798 20.7129 195.846 18.8296C195.33 18.316 194.871 17.7448 194.469 17.1176C193.264 15.4055 192.576 13.295 192.576 11.0117V10.7844C192.576 4.84983 197.396 0 203.362 0H219.656C225.624 0 230.5 4.84983 230.5 10.7844V11.0117L223.328 11.0693H223.329Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_540_2241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo-full.d7b92c741e7461415ddb0e742a5b5a94.svg";
export { ForwardRef as ReactComponent };